module.exports = __webpack_public_path__ + "static/img/组 2945.f06afbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/组 2945.png
// module id = t3sl
// module chunks = 0